import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as yup from "yup";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  accessToken: yup.string().required(),
  saveAll: yup.boolean().required(),
  saveNew: yup.boolean().required(),
});

export function useSaveConstantContactAuthDataMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.post(HTTP_ENDPOINTS.constantContact.saveAuthData(), {
        is_enabled: !!req.accessToken,
        access_token: req.accessToken,
        sync_all: req.saveAll,
        sync_new: req.saveNew,
        code: req.accessToken,
      });
    },
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.constantContact.authData],
        });
        options?.onSuccess?.();
      },
    },
  );
}
